export default "__VITE_ASSET__a99882ae__"